import { observer } from 'src/utils/mobx-react';
import { AutotraderRunType } from 'src/api_openapi/v2/automations/schemas';
import {
    CopyIconStyled,
    EventsDetailsWrapper,
    EventsIdsWrapper,
    HeaderBodyCell,
    HeaderBodyRow,
    IconWrapper,
    LogErrorWrapper,
    SaveIconStyled,
} from 'src/components/AutomationTrading/AutomationItem/AutomationItem.style';
import { Tooltip } from 'src/components/Tooltip/Tooltip';
import { DateTime } from 'src_common/utils/time/time';
import React from 'react';
import {
    AutomationEventsType,
    AutomationLogsType,
    AutomationPopupTypes,
} from 'src/components/AutomationTrading/AutomationPopup/AutomationPopup.state';

type AutotraderLogsType = Exclude<AutotraderRunType['log'], undefined>;
export type AutotraderLogsEventsOverviewKind = Extract<
    AutotraderLogsType[number],
    { kind: 'eventsOverview' }
>['eventsOverview'];

export type AutotraderLogsErrorKind = AutotraderLogsType[number];

class HistoryItemState {
    public constructor(private readonly props: HistoryItemPropsType) {}

    public getEventsData = (): AutotraderLogsEventsOverviewKind | null => {
        const autoTraderItemLog = this.props.item.log;
        if (autoTraderItemLog === undefined) {
            return null;
        }

        for (const autoTraderItemLogElement of autoTraderItemLog) {
            if (autoTraderItemLogElement.kind === 'eventsOverview') {
                return autoTraderItemLogElement.eventsOverview;
            }
        }

        return null;
    };

    public openEventDetails = (): void => {
        const events = this.getEventsData();
        if (events === null) {
            return;
        }
        const data: AutomationEventsType = {
            type: 'events',
            data: events,
        };

        this.props.onOpenPopup(data);
    };

    public openLogDetails = (): void => {
        const logs = this.props.item.log;
        if (logs === undefined) {
            return;
        }
        const data: AutomationLogsType = {
            type: 'logs',
            data: logs,
        };
        this.props.onOpenPopup(data);
    };

    public copyToClipboard = async (): Promise<void> => {
        const data = this.getEventsData()?.map((item) => item.id);

        console.log('data ', data);
        try {
            await navigator.clipboard.writeText(JSON.stringify(data, null, 2));
            console.log('Copying to clipboard was successful!');
        } catch (err) {
            console.error('Could not copy text to clipboard: ', err);
        }
    };
}

type HistoryItemPropsType = {
    item: AutotraderRunType;
    onOpenPopup: (item: AutomationPopupTypes | null) => void;
};
export const HistoryItem = observer('HistoryItem', (props: HistoryItemPropsType) => {
    const [state] = React.useState(() => new HistoryItemState(props));
    return (
        <HeaderBodyRow>
            <HeaderBodyCell>{props.item.id}</HeaderBodyCell>
            <HeaderBodyCell>{props.item.userId}</HeaderBodyCell>
            <HeaderBodyCell>
                <EventsDetailsWrapper>
                    <EventsIdsWrapper>{`Events No.: ${state.getEventsData() === null ? 'N/D' : state.getEventsData()?.length}`}</EventsIdsWrapper>
                    <IconWrapper>
                        <Tooltip content='Copy'>
                            <SaveIconStyled onClick={state.copyToClipboard} />
                        </Tooltip>
                        <Tooltip content='Show more'>
                            <CopyIconStyled onClick={state.openEventDetails} />
                        </Tooltip>
                    </IconWrapper>
                </EventsDetailsWrapper>
            </HeaderBodyCell>
            <HeaderBodyCell>{DateTime.from(props.item.createdAt)?.format()}</HeaderBodyCell>
            <HeaderBodyCell>
                {props.item.state === 'error' ? (
                    <Tooltip content='Error details'>
                        <LogErrorWrapper onClick={state.openLogDetails}>{props.item.state}</LogErrorWrapper>
                    </Tooltip>
                ) : (
                    props.item.state
                )}
            </HeaderBodyCell>
        </HeaderBodyRow>
    );
});
